'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const Dot6x6Icon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" fill="currentColor" /></svg>);